import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import PassportView from '@/views/PassportView.vue'
import GeneratePassports from '@/views/GeneratePassports.vue'
import Admin from '@/views/Admin.vue'
import Batches from '@/views/Batches.vue'
import { isAdmin, login } from '@/auth'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/generate',
    name: 'GeneratePassports',
    component: GeneratePassports,
    meta: { requiresAuth: true }
  },
  {
    path: '/batches',
    name: 'Batches',
    component: Batches,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: { requiresAuth: true }
  },
  {
    path: '/:identifier',
    name: 'PassportView',
    component: PassportView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Guard для защищенных роутов
router.beforeEach(async (to) => {
  if (to.meta.requiresAuth && !isAdmin() && !(await login())) {
    return '/'
  }
})

export default router
